export { PlaceholderLandscapeCollection } from './PlaceholderLandscapeCollection'
